module.exports = __webpack_public_path__ + "h5/img/list-bg.6007b7f5.png";